var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { Elements, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { useLocalize } from "../../utils/text.util";
import { NoShowByMailService } from "../../services/public/noShowByMail.service";
var StripeForm = function (props) {
    var stripe = useStripe();
    var elements = useElements();
    var t = useLocalize().t;
    var _a = useState(false), submitting = _a[0], setSubmitting = _a[1];
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!stripe || !elements)
                        return [2 /*return*/];
                    setSubmitting(true);
                    return [4 /*yield*/, stripe.confirmSetup({
                            elements: elements,
                            confirmParams: { return_url: props.returnUrl }
                        })];
                case 1:
                    error = (_a.sent()).error;
                    setSubmitting(false);
                    if (error)
                        props.onError(error.message || '');
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("form", __assign({ onSubmit: handleSubmit, style: { width: '100%', maxWidth: '400px', display: 'flex', flexDirection: 'column', alignItems: 'center' } }, { children: [_jsx(PaymentElement, {}), submitting
                ? _jsx(CircularProgress, { sx: { mt: '20px' } })
                : (_jsx(Button, __assign({ type: "submit", variant: "contained", disabled: !stripe, sx: { mt: '20px', width: '100%' }, className: "submit-button" }, { children: t('Add card') })))] })));
};
var NoShowWidget = function (_a) {
    var _b, _c;
    var noShowToken = _a.noShowToken;
    var t = useLocalize().t;
    var _d = useState('loading'), state = _d[0], setState = _d[1];
    var _e = useState(null), info = _e[0], setInfo = _e[1];
    var _f = useState(''), errorMessage = _f[0], setErrorMessage = _f[1];
    var searchParams = useSearchParams()[0];
    var stripePromiseRef = useRef(null);
    // Confirm exactly once per page load; StrictMode (dev) runs the effect below twice
    var confirmStartedRef = useRef(false);
    var returnUrl = "".concat(window.location.origin).concat(window.location.pathname);
    var confirmPayment = function (checkoutId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setState('confirming');
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, NoShowByMailService.confirmNoShowPayment(noShowToken, checkoutId)];
                case 2:
                    _b.sent();
                    setState('success');
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    setState('confirm_failed');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var redirectStatus = searchParams.get('redirect_status');
        var resourcePath = searchParams.get('resourcePath');
        if (redirectStatus === 'succeeded' || resourcePath) {
            if (confirmStartedRef.current)
                return;
            confirmStartedRef.current = true;
            // Hobex appends the checkout the card was submitted on as `id`
            confirmPayment(resourcePath ? searchParams.get('id') : null);
            return;
        }
        NoShowByMailService.getNoShowInfo(noShowToken)
            .then(function (data) {
            setInfo(data);
            setState(data.reservationStatus === 'CONFIRMED' ? 'already_confirmed' : 'payment');
        })
            .catch(function () { return setState('invalid'); });
    }, [noShowToken]);
    useEffect(function () {
        var _a;
        var hobex = (_a = info === null || info === void 0 ? void 0 : info.paymentSetupInfo) === null || _a === void 0 ? void 0 : _a.hobexSetupIntentDTO;
        if (state !== 'payment' || !(hobex === null || hobex === void 0 ? void 0 : hobex.checkoutId) || !(info === null || info === void 0 ? void 0 : info.hobexWidgetBaseUrl))
            return;
        var script = document.createElement('script');
        script.src = "".concat(info.hobexWidgetBaseUrl, "/v1/paymentWidgets.js?checkoutId=").concat(hobex.checkoutId);
        script.async = true;
        document.body.appendChild(script);
        return function () {
            if (document.body.contains(script))
                document.body.removeChild(script);
        };
    }, [state, (_c = (_b = info === null || info === void 0 ? void 0 : info.paymentSetupInfo) === null || _b === void 0 ? void 0 : _b.hobexSetupIntentDTO) === null || _c === void 0 ? void 0 : _c.checkoutId]);
    var renderPayment = function () {
        if (!(info === null || info === void 0 ? void 0 : info.paymentSetupInfo))
            return null;
        var paymentSetupInfo = info.paymentSetupInfo, stripePublicKey = info.stripePublicKey, hobexWidgetBaseUrl = info.hobexWidgetBaseUrl, restaurantName = info.restaurantName;
        var heading = (_jsxs(Typography, __assign({ variant: "h5", textAlign: "center" }, { children: [t('Secure your reservation at'), " ", _jsx("strong", { children: restaurantName || '' })] })));
        if (paymentSetupInfo.stripeSetupIntentDTO && stripePublicKey) {
            var _a = paymentSetupInfo.stripeSetupIntentDTO, clientSecret = _a.clientSecret, connectedAccountId = _a.connectedAccountId;
            if (!stripePromiseRef.current) {
                stripePromiseRef.current = loadStripe(stripePublicKey, {
                    stripeAccount: connectedAccountId || undefined
                });
            }
            return (_jsxs(Stack, __assign({ alignItems: "center", width: "100%", maxWidth: 500, gap: 3 }, { children: [heading, _jsx(Elements, __assign({ stripe: stripePromiseRef.current, options: { clientSecret: clientSecret } }, { children: _jsx(StripeForm, { returnUrl: returnUrl, onError: setErrorMessage }) })), errorMessage && _jsx(Typography, __assign({ color: "error" }, { children: errorMessage }))] })));
        }
        if (paymentSetupInfo.hobexSetupIntentDTO && hobexWidgetBaseUrl) {
            return (_jsxs(Stack, __assign({ alignItems: "center", width: "100%", maxWidth: 500, gap: 3 }, { children: [heading, _jsx("form", { action: returnUrl, className: "paymentWidgets", "data-brands": paymentSetupInfo.hobexSetupIntentDTO.brands || 'VISA MASTER AMEX', style: { width: '100%' } })] })));
        }
        return null;
    };
    switch (state) {
        case 'loading':
        case 'confirming':
            return (_jsx(Box, __assign({ display: "flex", justifyContent: "center", p: 4 }, { children: _jsx(CircularProgress, {}) })));
        case 'invalid':
            return (_jsxs(Stack, __assign({ alignItems: "center", gap: 2 }, { children: [_jsx(ErrorIcon, { color: "error", sx: { fontSize: 50 } }), _jsx(Typography, __assign({ variant: "h6" }, { children: t('No-show link is invalid or has expired.') }))] })));
        case 'confirm_failed':
            return (_jsxs(Stack, __assign({ alignItems: "center", gap: 2 }, { children: [_jsx(ErrorIcon, { color: "error", sx: { fontSize: 50 } }), _jsx(Typography, __assign({ variant: "h6" }, { children: t('Your card could not be confirmed.') })), _jsx(Typography, { children: t('Please open the link from your email again and re-enter your card details.') })] })));
        case 'already_confirmed':
        case 'success':
            return (_jsxs(Stack, __assign({ alignItems: "center", gap: 2 }, { children: [_jsx(CheckCircleIcon, { color: "success", sx: { fontSize: 50 } }), _jsx(Typography, __assign({ variant: "h5" }, { children: t('Your reservation is confirmed') })), _jsx(Typography, { children: t('Your card has been saved and your reservation is confirmed.') })] })));
        case 'payment':
            return renderPayment();
        default:
            return null;
    }
};
export default NoShowWidget;
